<template>
  <div class="page">
    <ion-grid>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="4">
              <ion-label>Reservation No</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input 
                  class="form-input" 
                  type="text" 
                  id="id" 
                  @input="id = $event.target.value">
                </ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4">
              <ion-label>Corporate Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input 
                  class="form-input" 
                  type="text" 
                  id="corporateName" 
                  @input="corporateName = $event.target.value">
                </ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4">
              <ion-label>Branch Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input 
                  class="form-input" 
                  type="text" 
                  id="branchName" 
                  @input="branchName = $event.target.value">
                </ion-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="4">
              <ion-label>station Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input 
                  class="form-input" 
                  type="text" 
                  id="stationName" 
                  @input="stationName = $event.target.value">
                </ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                  >
                  <ion-select-option
                  v-for="(status, index) in this.statuses"
                  :key="index"
                  :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>
                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                  >
                  <option
                  v-for="(status, index) in this.statuses"
                  :key="index"
                  :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4">
              <ion-label>Customer Mobile</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input 
                  class="form-input" 
                  type="text" 
                  id="customerMobile" 
                  @input="customerMobile = $event.target.value">
                </ion-input>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" size-md="4">
              <ion-label>Reservation Date From</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class="form-vue-picker"
                  inputFormat="dd/MMM/yyyy"
                  placeholder="DD/MON/YYYY"
                  v-model="reservationFrom"
                  :typeable="true"
                  :lowerLimit ="sixMonthsAgo"
                  :upperLimit ="currentDate"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <datepicker 
                  v-model="reservationFrom" 
                  inputFormat="dd/MMM/yyyy"
                  class="form-picker" 
                  placeholder="Select From Date"
                  @change="reservationFrom = $event.target.value"
                  :value = reservationFrom
                  :lowerLimit ="sixMonthsAgo"
                  :upperLimit ="currentDate"
                />
                <span class="input-icon-calendar">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4">
              <ion-label>Reservation Date To</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class="form-vue-picker"
                  inputFormat="dd/MMM/yyyy"
                  placeholder="DD/MON/YYYY"
                  v-model="reservationTo"
                  :lowerLimit="sixMonthsAgo"
                  :upperLimit="maxDate"
                  :typeable="true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <datepicker 
                  v-model="reservationTo"
                  :lowerLimit="sixMonthsAgo"
                  :upperLimit="maxDate"
                  inputFormat="dd/MMM/yyyy"
                  class="form-picker" 
                  placeholder="Select To Date"
                  @change="reservationTo = $event.target.value"
                  :value = reservationTo
                />
                <span class="input-icon-calendar">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
            </ion-col>
            <ion-col size="12" size-md="4">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchCPOReservations">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
            <ion-col size="12" size-md="1">
              <ion-label>Res.No</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Corporate & Branch Name</ion-label>
            </ion-col>
            <!-- <ion-col size="12" size-md="2">
              <ion-label>Branch Name</ion-label>
            </ion-col> -->
            <ion-col size="12" size-md="2">
              <ion-label>Stations Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Mobile</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Res.Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv.#</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv.Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv.Total</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>kWh</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />
          <ion-row class="list-item" v-for="(reservation) in this.reservations" :key="reservation">
            <ion-col size="12" size-md="1">
              <ion-label
              class="ext-link"
              @click="viewReservation(reservation.reservationId)"
              >{{reservation.refNo}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.corporateName}}, {{reservation.branchName}}</ion-label>
            </ion-col>
            <!-- <ion-col class="limit-length" size="12" size-md="2">
              <ion-label>{{reservation.branchName}}</ion-label>
            </ion-col> -->
            <ion-col size="12" size-md="2">
              <ion-label>{{reservation.stationName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.userName}}</ion-label>
            </ion-col>
             <ion-col size="12" size-md="1">
              <ion-label>{{reservation.mobile}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.reservationDate}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.invoiceNumber}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{changeDateFormatWithoutTime(reservation.invoiceDate)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.invoiceTotal}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.invoiceKwh}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label
                style="white-space: nowrap;"
                class="status-small"
                v-bind:class="[{'open': reservation.status.code === 'O'}, {'cancelled': reservation.status.code === 'X'}, {'wip': reservation.status.code === 'P'}, {'expired': reservation.status.code === 'E'}, {'completed': reservation.status.code === 'C'}]"
              >{{ convertUppercase(reservation.status.description) }}</ion-label> 
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class="ion-text-right">
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
            v-for="page in this.pagesList"
            :key="page"
            v-bind:class="{'active': pageNo == page}"
            @click="loadPage(page)"
            >{{page}}</a>
            <a
            class="next"
            v-if="this.pageNo < this.totalPages"
            @click="loadPage(pageNo + 1)"
            >Next</a>
            <a class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import {
  EVChargingReservation,
  EVChargingReservationStatus,
  EVChargingReservationTypeCode,
  ChargingReservationTypeInfo,
} from "@/entity/station/reservation";

import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";

// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import moment from "moment";
import { refresh } from 'ionicons/icons';

export default defineComponent ({
  name: 'cporeservations',
  components: {
    datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      reservations: [],
      statuses: [],
      types: [],
      statusModels: [],
      id: "",
      corporateName: "",
      branchName: "",
      stationName: "",
      status: "",
      customerMobile: "",
      reservationFrom:"",
      reservationTo: "",
      invoiceTotal: "",

      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 10,
      pageNo: 1,
      pagesList: [],
      totalPages: 0,

      reservationFrom: new Date(),
      reservationTo: new Date(),
      configDays: 0,
      configMonths: 0,
      maxDate: new Date(), // Current date
      currentDate: new Date(),
      sixMonthsAgo: new Date(),
    }
  },
  async mounted() {
    await this.getDateAndMonth()
    await this.getDateDaysAgo(this.configDays)
    await this.getDateMonthsAgo(this.configMonths)
    this.statuses = await new EVCStationReservationService().reservationStatuses();
    this.statusModels = [];
    this.statuses.forEach((status) => {
      this.statusModels.push({
        text: status.name,
        value: status.id,
      });
    });

    // this.reservationFrom = new Date();
    // this.reservationTo = new Date();
    var page = localStorage.getItem("cpoReservationPage");
    if (page) {
      this.pageNo = Number(page);
    }
    
    var search = localStorage.getItem("cpoReservationSearch");
    if (search) {
      search = JSON.parse(search);
      this.id = search.id;
      this.corporateName = search.corporateName;
      this.branchName = search.branchName;
      this.stationName = search.stationName;
      document.getElementById("id").value = search.id;
      document.getElementById("corporateName").value = search.corporateName;
      document.getElementById("branchName").value = search.branchName;
      document.getElementById("stationName").value = search.stationName;
      document.getElementById("customerMobile").value = search.stationName;
      this.reservationFrom = new Date(search.reservationFrom);
      this.reservationTo = new Date(search.reservationTo);
      this.status = search.status;
      this.mobile = search.customerMobile
    }
    await this.searchCPOReservations();
    this.loaderTab = false;
  },
  methods: {
    async getDateAndMonth() {
      this.configValue = await new CorporateService().getConfigValueOfDateAndMonth()
      this.configDays = this.configValue[0].description;
      this.configMonths = this.configValue[1].description
    },
    // Helper function to calculate a date 'n' days ago
    async getDateDaysAgo(days) {
      const date = new Date();
      date.setDate(date.getDate() - days);
      this.reservationFrom =  date;
    },
    async getDateMonthsAgo(months) {
      const date = new Date();
      date.setMonth(date.getMonth() - months);
      this.sixMonthsAgo = date;
    },
    changeDateFormatWithoutTime(dateValue) {
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
    },
    convertUppercase(value) {
      if(value != undefined || value != null) {
        return value.toUpperCase()
      }
    },
    viewReservation(reservationId) {
      this.$router.push({
        path: "/admin/reservations/reservation/"+reservationId,
        params: { bookingId: reservationId },
      });
      // this.$router.push('/admin/reservations/reservation')
    },
    async clearFields() {
      this.id = null;
      this.corporateName = null;
      this.branchName = null;
      this.stationName = null;
      this.customerMobile = null;
      document.getElementById("id").value = null;
      document.getElementById("corporateName").value = null;
      document.getElementById("branchName").value = null;
      document.getElementById("stationName").value = null;
      document.getElementById("customerMobile").value = null;
      this.reservationFrom = null;
      this.reservationTo = null;
      this.status = null;  
      localStorage.removeItem("cpoReservationSearch");
      localStorage.removeItem("cpoReservationPage");
      this.reservations = [];
      this.reservationTo = new Date();
      await this.getDateAndMonth()
      await this.getDateDaysAgo(this.configDays)
      await this.getDateMonthsAgo(this.configMonths)
      await this.searchCPOReservations();
      // this.norecordsfound = true; //Modified by Swide on 2020-12-16 Bug#3 
    },
    async searchCPOReservations() {
      this.pageNo = 1;
      this.pageRecords = 10;
      if (
        this.reservationFrom &&
        this.reservationTo &&
        new Date(this.reservationFrom) > new Date(this.reservationTo)
      ) {
        new ToastUtils().presentToast(
          "Please select correct date range of Reservation. From date should less than To date"
        );
        this.reservations = [];
        this.norecordsfound = true;
      } else {
        this.loaderTab = true;
        
        let result = await new CorporateService().cpoReservationsAccessibleByCPOUserAtPageByPaginatedWithSizeMatchingQuery(
          new LocalStorage().user,
          this.pageNo,
          this.pageRecords,
          {
            id: this.id,
            station: {
              name: this.stationName,
            },
            corporate: {
              name: this.corporateName,
            },
            branch: {
                name: this.branchName
            },
            reservedBetween: {
              from: this.reservationFrom ? new Date(this.reservationFrom) : null,
              to: this.reservationTo ? new Date(this.reservationTo) : null,
            },
            status: new EVChargingReservationStatus(this.status, ""),
            mobile: this.customerMobile
            
          }
        );
        if(result.total > 0) {
          this.totalRecords = result.total;
          this.reservations = result.fetched;
          
          (this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            this.pageNo
          )),
            (this.totalPages = new PaginationUtils().getTotalPages(
              this.totalRecords,
              this.pageRecords
            ));
          this.norecordsfound = false;
          this.loaderTab = false;
        } else {
          this.reservations = [];
          this.norecordsfound = true;
          this.loaderTab = false;
        }
        
        new ToastUtils().presentToast("Search completed");
      }
    },
    async loadPage(page) {
      localStorage.setItem("cpoReservationPage", page);
      this.loaderTab = true;
      this.pageNo = page;
      this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        page
      );

      let result = await new CorporateService().cpoReservationsAccessibleByCPOUserAtPageByPaginatedWithSizeMatchingQuery(
          new LocalStorage().user,
          this.pageNo,
          this.pageRecords,
          {
            id: this.id,
            station: {
              name: this.stationName,
            },
            corporate: {
              name: this.corporateName,
            },
            branch: {
                name: this.branchName
            },
            reservedBetween: {
              from: this.reservationFrom ? new Date(this.reservationFrom) : null,
              to: this.reservationTo ? new Date(this.reservationTo) : null,
            },
            status: new EVChargingReservationStatus(this.status, ""),
            mobile: this.customerMobile
            
          }
        );
      this.totalRecords = result.total;
      this.reservations = result.fetched;
      this.loaderTab = false;
    },
  },
})
</script>

<style scoped>
.status-completed {
  background: #21b24b 0% 0% no-repeat padding-box;
  border-radius: 36px;
  padding-left: 5px;
  padding-top: 0px;
  padding-right: 5px;
  padding-bottom: 0px;
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 13px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.status-cancelled {
  background: #a7a7a7 0% 0% no-repeat padding-box;
  border-radius: 36px;
  padding-left: 5px;
  padding-top: 0px;
  padding-right: 5px;
  padding-bottom: 0px;
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 13px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}
.limit-length {
  width: 1% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>